import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ClearingAgent } from 'src/app/core/models/clearing-agent';
import { ClearingAgentService } from 'src/app/core/services/general/clearing-agent.service';

@Component({
  selector: 'app-clearing-agent-input',
  templateUrl: './clearing-agent-input.component.html',
  styleUrls: ['./clearing-agent-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ClearingAgentInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ClearingAgentInputComponent,
    },
  ],
})
export class ClearingAgentInputComponent {
  @Input()
  title = "Select Clearing Agent...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public clearingAgentsList: Array<CustomSelectOption> = [];

  constructor(
    private clearingAgentService: ClearingAgentService,
  ) {
    this.clearingAgentService
      .all()
      .subscribe((res: Array<ClearingAgent>) => {
        this.clearingAgentsList = res.map((el) => {
          return {
            name: `${el.first_name} ${el.last_name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.clearingAgentsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
